import {IAttributes, IAugmentedJQuery, IController, IOnChangesObject, ISCEService, ITimeoutService} from "angular";
import {dersomChangesInneholder} from "../../stoettefunk/angularHjelpemetoder";
import {AutoTagType} from "../../direktiver/ckeditor";
import debug from "debug";

let css = require('./htmlFormatert.scss');

/**
 * Viser html-formatert innhold.
 */
export abstract class HtmlFormatertKontroller implements IController {

    constructor(private $element: IAugmentedJQuery, private $attrs: IAttributes, private $timeout: ITimeoutService, private $sce: ISCEService) {
        this.cssClass = $attrs['class'] || '';
        this.begrensetHøyde = this.$attrs['begrensetHoyde'] !== undefined;
    }

    innhold: string; //settes via bindings i konkret subklasse
    cssClass: string; //settes via bindings i konkret subklasse

    sikkertInnhold: string;

    private begrensetHøyde = false;
    private htmlformatertElement: IAugmentedJQuery;

    $postLink(): void {
        this.$element.on('click.autotag', 'a', ($event: JQueryEventObject) => {
            this.håndterKlikkPåATag($event.currentTarget);
            return false;
        });
        this.htmlformatertElement = this.$element.children('div.ckeditor-innhold');
        if (this.begrensetHøyde)
            this.htmlformatertElement.addClass('htmlformatert-begrenset');
    }

    $onDestroy(): void {
        this.$element.off('click.autotag', 'a');
    }

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'innhold', innhold => {
            //vi forutsetter at html allerede er vasket og sørger følgelig her for at html ikke vaskes på nytt av angular
            this.sikkertInnhold = this.$sce.trustAsHtml(innhold);
            if (this.begrensetHøyde)
                this.$timeout(() => this.håndterBegrensetHøyde()); //må legges i timeout slik at html har blitt oppdatert
        });
    }

    private håndterBegrensetHøyde() {
        //console.log('# htmlformatert onchange timout', this.htmlformatertElement.innerHeight(), this.htmlformatertElement)
        if (this.htmlformatertElement.innerHeight() < 55)
            this.htmlformatertElement.removeClass('htmlformatert-begrenset');
        else
            this.htmlformatertElement.addClass('htmlformatert-begrenset');
    }

    private håndterKlikkPåATag(linkElement: Element) {
        //console.log('KLIKK', linkElement);
        if (linkElement.hasAttribute('data-autotag'))
            this.håndterAutoTagLenke(this.autoTagType(linkElement.getAttribute('data-type')), linkElement.getAttribute('data-id'));
        else
            this.håndterLenke(linkElement.getAttribute('href'));
    }

    private autoTagType(type: string): AutoTagType {
        if (AutoTagType[type] == undefined)
            console.error(`ukjent autotag type ${type}`);
        return AutoTagType[type];
    }

    /** håndterer klikk på lenke.
     * Må overstyres i subklasse  */
    abstract håndterLenke(url: string)

    /** håndterer klikk på autotag-lenke (se ckeditor autotag plugin).
     * Må overstyres i subklasse  */
    abstract håndterAutoTagLenke(type: AutoTagType, id: string)

}

